
// Form validation
// Validates full form before final submit
// ----------------------------------------------------------------

import $ from 'jquery';

export function validationForm(form) {
    var formSubmitCheck = form.find('.js-formErrorMessage');

    if ($(formSubmitCheck).hasClass('js-errorMessageVisible')) {
        return false;
    } else {
        return true;
    }
}
